export const checkPeriodLearnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/how-to-set-up-a-check-period-for-budgets-quickbooks-online';
export const zeroAmountLearnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/does-approvalmax-support-checking-budgets-against-0-lines-quickbooks-online';
